exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear[data-v-4c0f1704] {\n  text-align: justify;\n}\n.h2_title[data-v-4c0f1704] {\n  font-weight: normal;\n}\n", ""]);

// exports
